import React from 'react';
import { Feature } from 'core/enums/features';
import { BaseRoute } from 'core/models/base-routes';

export const RewardHistoryRoutes: BaseRoute[] = [
  {
    path: '*',
    title: 'All',
    name: 'rewards.history.tabs.all',
    feature: Feature.RewardsHistory,
    component: React.lazy(() => import('./tabs/all-rewards')),
    hideFromMainMenu: true,
    icon: 'icon-list',
  },
  {
    path: 'claimed',
    title: 'Claimed Rewards',
    name: 'rewards.history.tabs.claimed',
    feature: Feature.RewardsHistory,
    component: React.lazy(() => import('./tabs/claimed')),
    hideFromMainMenu: true,
    icon: 'icon-decoder',
  },
  {
    path: 'entered',
    title: 'Competitions Entered',
    name: 'rewards.history.tabs.competitions',
    feature: Feature.RewardsHistory,
    component: React.lazy(() => import('./tabs/entered')),
    hideFromMainMenu: true,
    icon: 'icon-Holiday_home',
  },
  {
    path: 'missed',
    title: 'Missed',
    name: 'rewards.history.tabs.missed',
    feature: Feature.RewardsHistory,
    component: React.lazy(() => import('./tabs/missed')),
    hideFromMainMenu: true,
    icon: 'icon-happy-face',
  },
];